/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ModalitaMappa } from './modalita-mappa';
import { AmbitoRegolaPunteggio } from './ambito-regola-punteggio';
import { Aggregatore } from './aggregatore';


export interface TipoPraticaRegolaPunteggioListFilter { 
    ambito?: AmbitoRegolaPunteggio;
    modalita_mappa?: ModalitaMappa;
    aggregatore?: Aggregatore;
}



